
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, nextTick, onUnmounted, h } from 'vue'
import { useRoute } from 'vue-router'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import f10Api from '@/api/f10ApiHk'
import ws from '@/websocket/index'
import { eventBus } from '@/utils/eventBus'
export default defineComponent({
  components: { Table, Nodata },
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      total: 0,
      pagination: {},
      spinning: true,
      isDelayHK: false
    })
    pageData.total = computed(() => {
      return ((props.pageSourceData || {}).InvestActivity || {}).Total || 0
    })
    pageData.pagination = computed(() => {
      return {
        total: pageData.total,
        showSizeChanger: true,
        showTotal: (total: number) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showQuickJumper: false,
        onChange: changeSize,
        onShowSizeChange: changeSize
      }
    })

    // 根据涨跌额返回颜色类名
    const getPriceColorClass = (riseandFall: number | null) => {
      if (riseandFall === null || riseandFall === undefined) {
        return ''
      }
      if (riseandFall > 0) {
        return 'red'
      } else if (riseandFall < 0) {
        return 'green'
      } else {
        return ''
      }
    }

    pageData.columns = [
      {
        title: '序',
        dataIndex: 'startDate',
        key: 'startDate',
        width: '100px'
      },
      {
        title: '代码',
        dataIndex: 'endDate',
        key: 'endDate',
        width: '100px'
      },
      {
        title: '名称',
        dataIndex: 'MS',
        key: 'MS',
        width: '375px',
        ellipsis: true,
        // 名称后显示"延"标签（当该行是延时行情时）
        customRender: ({ record }: any) => {
          const nameNode = h('span', { class: 'name-ellipsis' }, record.MS)
          const delayNode = pageData.isDelayHK ? h('span', { class: 'delay-badge', title: '延时' }, '延') : null
          return {
            children: h('span', { class: 'name-with-badge' }, [nameNode, delayNode])
          }
        }
      },
      {
        title: '持仓占比',
        dataIndex: 'Participant',
        key: 'Participant',
        width: '150px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '最新价',
        dataIndex: 'Place',
        key: 'Place',
        width: '200px',
        ellipsis: true,
        customRender: ({ record }: any) => ({
          children: h('span', {
            class: getPriceColorClass(record._riseandFall)
          }, record.Place)
        })
      },
      {
        title: '涨跌幅',
        dataIndex: 'ListingCreper',
        key: 'ListingCreper',
        width: '150px',
        ellipsis: true,
        customRender: ({ record }: any) => ({
          children: h('span', {
            class: getPriceColorClass(record._riseandFall)
          }, record.ListingCreper)
        })
      },

    ]
    onMounted(() => {
      getResearchDetail()
    })
    const route = useRoute()

    const formatPriceHK = (v: number | null) => v == null ? '—' : Number(v).toFixed(2)
    const formatPctHK = (v: number | null) => v == null ? '—' : `${Number(v).toFixed(2)}%`

    // ETF批量订阅
    function subscribeEtfs(rows: any[]) {
      console.log('开始批量订阅ETF:', rows.length, '个')

      // 使用批量订阅替代逐个订阅
      const stockList = rows.map(r => ({
        symbol: r._symbol,
        market: pageData.isDelayHK ? 'DELAY_' + r.market : r.market
      }))

      // 批量订阅
      ws.websocket.safeSubscribeList('ETF_LIST', stockList)
    }

    // 通过eventBus监听其他股票消息
    const handleOtherStockMessage = (newMsg: any) => {
      if (!newMsg) return
      console.log('打印监听数据newMsg', newMsg)
      const q = newMsg?.QuoteData || {}
      const inst = newMsg?.Inst || q?.DynaData?.[0]?.InstrumentID || q?.StatisticsData?.[0]?.InstrumentID || q?.StaticData?.[0]?.InstrumentID
      if (!inst) return
      const idx = (pageData.data as any[]).findIndex((row: any) => String(row._symbol).toUpperCase() === String(inst).toUpperCase())
      if (idx === -1) return
      const row = (pageData.data as any[])[idx]

      // 按照 navtopF10.vue 的方式处理数据，将值保存到 row 中避免重置

      // 获取 PreClosePrice（与 navtopF10.vue 判断方式一致）
      if (q && q.StatisticsData && (q.StatisticsData || []).length > 0) {
        row._preClosePrice = Number(q.StatisticsData[0].PreClosePrice || 0)
      }

      // 获取 LastPrice（与 navtopF10.vue 判断方式一致）
      if (q && q.DynaData && (q.DynaData || []).length > 0) {
        row._lastPrice = q.DynaData[0].LastPrice || null
        row.Place = formatPriceHK(row._lastPrice)
      }

      // 获取 InstStatus（与 navtopF10.vue 判断方式一致）
      if (q && (q.InstStatusData || [])[0]) {
        row._instStatus = ((q.InstStatusData || [])[0] || {}).StatusType
      }

      // 计算涨跌幅和涨跌额（按照 navtopF10.vue 的逻辑）
      console.log('打印监听数据preClose状态', row)
      if (row._instStatus === 6) {
        // 停牌状态，涨跌幅为 null
        row._lastPrice = null
        row._riseandFall = null
        row.Place = formatPriceHK(row._lastPrice)
        row.ListingCreper = formatPctHK(null)
      } else if (row._preClosePrice && row._lastPrice != null) {

        const increase = ((Number(row._lastPrice) - row._preClosePrice) / row._preClosePrice) * 100
        // 正常计算涨跌幅和涨跌额
        row._riseandFall = Number(row._lastPrice) - row._preClosePrice
        row.ListingCreper = formatPctHK(increase)
      }
      console.log('打印监听数据preClose', row._preClosePrice, row._lastPrice, row._instStatus)


    }

    // 处理批量订阅返回的数据
    const handleHQLISTMessage = (msg: any) => {
      if (!msg || !msg.QuoteData || !msg.QuoteData.DynaData) return

      console.log('收到批量订阅数据:', msg)
      console.log('DynaData数量:', msg.QuoteData.DynaData.length)
      console.log('StatisticsData数量:', msg.QuoteData.StatisticsData?.length || 0)
      console.log('InstStatusData数量:', msg.QuoteData.InstStatusData?.length || 0)

      // 遍历返回的数据，更新对应的ETF信息
      msg.QuoteData.DynaData.forEach((msgItem: any) => {
        const idx = (pageData.data as any[]).findIndex((row: any) =>
          String(row._symbol).toUpperCase() === String(msgItem.InstrumentID).toUpperCase()
        )

        if (idx === -1) return
        const row = (pageData.data as any[])[idx]

        // 获取 PreClosePrice（批量订阅数据结构可能不同）
        if (msg.QuoteData && msg.QuoteData.StatisticsData && (msg.QuoteData.StatisticsData || []).length > 0) {
          const statData = msg.QuoteData.StatisticsData.find((stat: any) =>
            String(stat.InstrumentID).toUpperCase() === String(msgItem.InstrumentID).toUpperCase()
          )
          if (statData) {
            row._preClosePrice = Number(statData.PreClosePrice || 0)
          }
        }

        // 获取 InstStatus（批量订阅数据结构可能不同）
        if (msg.QuoteData && (msg.QuoteData.InstStatusData || []).length > 0) {
          const statusData = msg.QuoteData.InstStatusData.find((status: any) =>
            String(status.InstrumentID).toUpperCase() === String(msgItem.InstrumentID).toUpperCase()
          )
          if (statusData) {
            row._instStatus = statusData.StatusType
          }
        }

        // 更新价格信息
        if (msgItem.LastPrice !== undefined) {
          row._lastPrice = msgItem.LastPrice
          row.Place = formatPriceHK(row._lastPrice)
        }

        // 计算涨跌幅和涨跌额（按照 navtopF10.vue 的逻辑）
        console.log('打印批量订阅数据preClose状态', row)
        if (row._instStatus === 6) {
          // 停牌状态，涨跌幅为 null
          row._lastPrice = null
          row._riseandFall = null
          row.Place = formatPriceHK(row._lastPrice)
          row.ListingCreper = formatPctHK(null)
        } else if (row._lastPrice != null) {
          // 如果有涨跌幅数据，直接使用
          if (msgItem.UpdownRate !== undefined) {
            const increase = msgItem.UpdownRate * 100
            row.ListingCreper = formatPctHK(increase)
          }

          // 如果有涨跌额数据，直接使用
          if (msgItem.Updown !== undefined) {
            row._riseandFall = msgItem.Updown
          }

          // 如果有前收盘价，也计算一下作为备用
          if (row._preClosePrice && row._preClosePrice > 0) {
            const increase = ((Number(row._lastPrice) - row._preClosePrice) / row._preClosePrice) * 100
            row._riseandFall = Number(row._lastPrice) - row._preClosePrice
            row.ListingCreper = formatPctHK(increase)
          }
        }
        console.log('打印批量订阅数据preClose', row._preClosePrice, row._lastPrice, row._instStatus)
      })
    }

    // 注册eventBus监听
    eventBus.on('otherStockMessage', handleOtherStockMessage)

    // 注册批量订阅监听
    ws.websocket.on('onHQLIST', handleHQLISTMessage)

    // 组件卸载时移除监听
    onUnmounted(() => {
      eventBus.off('otherStockMessage', handleOtherStockMessage)
      ws.websocket.off('onHQLIST', handleHQLISTMessage)
    })

    const getBriefIndexInfos = () => {
      const token = props.token || 'e2bfcc9278acca667bdc6abd7a75598d'
      const ts = parseInt((new Date().getTime() / 1000) as any)
      const secret = 'U7KK2GV5GH68'
      const sign = window.Md5.hashStr(`${token}${ts}${secret}`)

      // 传参
      const data = {
        data: {
          token,
          _t: ts,
          _sign: sign
        },
        headers: {
          agent: 'pc_client',
          version: route.query.version,
        }
      }
      f10Api.getBriefIndexInfo(data).then((res: any) => {
        // pageData.isDelayHK = calcIsDelayHK(res?.data) 1是延时

        // if (route.query.market == 'hkse' || route.query.exchange == 'HKEX') {
        //   if (route.query.HKDELAY == '1') {
        //     pageData.isDelayHK = true
        //   } else {
        //     pageData.isDelayHK = false
        //   }
        // } else {
        //   if (route.query.USDELAY == '1') {
        //     pageData.isDelayHK = true
        //   } else {
        //     pageData.isDelayHK = false
        //   }
        // }


        pageData.isDelayHK = (route.query.market == 'hkse' || route.query.exchange == 'HKEX')
          ? route.query.HKDELAY == '1'
          : route.query.USDELAY == '1';

      }).catch(() => {
        pageData.isDelayHK = false
      })
    }
    function calcIsDelayHK(user: any) {
      const rights2 = Array.isArray(user?.quote_right2) ? user.quote_right2 : []
      const delay2 = rights2.some((it: any) => {
        const exch = String(it?.exchange || '').toUpperCase()
        const mkt = String(it?.market || '')
        return exch == 'HKEX' && mkt == '' && String(it?.right) == '0'
      })
      return delay2
    }
    function getResearchDetail() {

      pageData.spinning = true
      const data: any = {
        data: {
          // symbol: '00700',
          symbol: route.query.code || '00700',
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944',
        },
        headers: {

        },
      }
      f10Api.getBriefbaseInfo2(data).then((res: any) => {
        const list = res?.data?.relate_etf?.list || []
        // 先获取权限，决定是否延时（仅对港股/美股生效）
        getBriefIndexInfos()

        // 组装表格行
        const rows: any[] = list.map((it: any, i: number) => {
          const si = it?.symbol_info || {}
          const isDelay = pageData.isDelayHK && String(si?.exchange || '').toUpperCase() === 'HKEX'

          // 本地环境测试数据
          const testData = [
            { _symbol: '01304', market: 'hkse' },
            // { _symbol: '603239', market: 'sh' },
            // { _symbol: '601778', market: 'sh' }
          ]

          // 判断是否为本地环境
          const isLocal = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

          // 根据环境选择数据源 isLocal ? (testData[i] || testData[0]) :
          const symbolData = { _symbol: si.symbol, market: si.market || '' }

          return {
            // 表格现有列字段映射
            startDate: i + 1,
            endDate: symbolData._symbol,
            MS: si.name || '-',
            Participant: `${Number(it?.wgt || 0).toFixed(2)}%`,
            Place: '—',
            ListingCreper: '—',
            // 内部字段
            _symbol: symbolData._symbol,
            exchange: si.exchange || '',
            market: symbolData.market,
            isDelay
          }
        })
        pageData.data = rows
        // 订阅
        subscribeEtfs(rows)
        pageData.spinning = false
      }).catch(() => {
        pageData.spinning = false
      })

    }
    function changeSize(current: number, size: number) {
      // getResearchDetail(current,size)
      nextTick(() => {
        const wrapper: any = document.querySelector('.wrapper')
        const target: any = document.getElementById('dyhd')
        wrapper.scrollTop = target.offsetTop
      })
    }

    // 处理表格行点击事件
    const handleRowClick = (record: any) => {
      return {
        onClick: () => {
          console.log('打印点击数据record', record)
          // 获取股票代码和市场信息
          const symbol = record._symbol
          const market = record.market

          // 构建跳转 URL
          const jumpUrl = `gw://funccall?funcname=OnFireCommand;setcurrent=1;Command=fszs;param=<params>
    <code>${symbol}</code>
    <market_letter>${market}</market_letter>
    <technique_type>0</technique_type>
    <level2_orderchart_type>-1</level2_orderchart_type>
    <StyleName>FSZS</StyleName>
    <TabName>分时图</TabName>
    <flag_container_style>R</flag_container_style>
</params>`

          // 执行跳转
          window.open(jumpUrl)
        }
      }
    }

    return {
      ...toRefs(pageData),
      getPriceColorClass,
      handleRowClick,

    }
  }
})
